/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Empty from './Empty/index'
import PreviewImage from './PreviewImage/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageComparison/Content/Sections/Section/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Empty'
let comparisonSectionImageIdValueData = fromData.useDataFormat({ viewPath,
context: 'comparison_section',
path: 'image_id',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: comparisonSectionImageIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PreviewImage'}>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}